// extracted by mini-css-extract-plugin
module.exports = {"container":"attention-container__yVCnD"};